import { render, staticRenderFns } from "./addSampleInfo.vue?vue&type=template&id=c62a4ae8&scoped=true&"
import script from "./addSampleInfo.vue?vue&type=script&lang=js&"
export * from "./addSampleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62a4ae8",
  null
  
)

export default component.exports